@if (neskoServiceVerfuegbar) {
  <ng-container title>
    <h3 class="mb-0 mt-3">{{ "neskoab.AmtlicherWert" | translate }}</h3>
  </ng-container>
  <ng-container>
    @if (listLoader) {
      <cap-list-loader
        [defaultText]="'gemaessAmtlicherBewertung'"
        [hasRight]="neskoEntry?.mAmtlicherWert?.access === 'ALLOWED'"
        [listLoader]="listLoader"
        [showTotal]="false">
        <div class="cap-list-loader-content">
          <table class="cap-table-detail">
            <thead>
              <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
            </thead>
            <tbody>
              <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
            </tbody>
          </table>
        </div>
      </cap-list-loader>
    }
  </ng-container>
  <ng-template #tableHeaders>
    <tr>
      <th>{{ "neskoab.AmtlicherWert" | translate }}</th>
      <th>{{ "neskoab.ErtragswertBGBB" | translate }}</th>
      <th>{{ "neskoab.Totalflaeche" | translate }}</th>
      <th>{{ "neskoab.GueltigAbSteuerjahr" | translate }}</th>
    </tr>
  </ng-template>
  <ng-template #tableRows>
    @for (item of listLoader?.items; track item) {
      <tr>
        <td>
          @if (item.isAmtlicherWertVerteilt) {
            <span> ({{ item.amtlicherWert | betrag: true }}) 0 </span>
          }
          @if (!item.isAmtlicherWertVerteilt) {
            <span>
              {{ item.amtlicherWert | betrag: true }}
            </span>
          }
          @if (item.isKennzeichnungErtragswert && item.amtlicherWert && !item.ertragswertNachBGBB) {
            <span>
              {{ "(mit Ertragswertkomponente)" | translate }}
            </span>
          }
        </td>
        <td>
          {{ item.ertragswertNachBGBB | betrag: true }}
        </td>
        <td>{{ item.flaeche | decimalHochkomma }}&nbsp;m²</td>
        <td>
          {{ item.gueltigAbSteuerjahr }}
        </td>
      </tr>
    }
  </ng-template>
  <ng-container title>
    <h3 class="mb-0">{{ "neskoab.EigentumVerteiler" | translate }}</h3>
  </ng-container>
  @if ((neskoEntry?.verteiler && neskoEntry?.verteiler.length != 0) || neskoEntry?.eigentum) {
  } @else {
    <div class="mb-2">
      <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
    </div>
  }
  @if (neskoEntry?.verteiler && neskoEntry?.verteiler.length > 0) {
    <cap-neskoab-grundstueck-eigentum
      [eigentum]="neskoEntry?.verteiler"
      [eigentumsform]="neskoEntry?.eigentum?.eigentumForm"
      [hasRight]="hasRightVerteiler">
    </cap-neskoab-grundstueck-eigentum>
  } @else {
    @if (neskoEntry?.eigentum) {
      <cap-neskoab-personen-eigentum [eigentum]="[neskoEntry?.eigentum]" [hasRight]="hasRightEigentum"></cap-neskoab-personen-eigentum>
    }
  }
} @else {
  <div class="mt-3">
    <cap-bsg-alert [type]="'warning'">
      {{ "neskoab.nichtVerfuegbar" | translate }}
    </cap-bsg-alert>
  </div>
}

<ng-template #nichtVerfuegbar>
  <div class="mt-3">
    <cap-bsg-alert [type]="'warning'">
      {{ "neskoab.nichtVerfuegbar" | translate }}
    </cap-bsg-alert>
  </div>
</ng-template>
